/**
 * تحويل إسقاطي ثنائي الأبعاد (Homography) من مستطيل إلى رباعي أضلاع،
 * معبَّرًا عنه كـ CSS matrix3d — لتثبيت درفة الباب على فتحة مائلة بالمنظور الحقيقي.
 * الزوايا بالترتيب: tl, tr, br, bl (بالبكسل نسبةً إلى الزاوية العلوية اليسرى للعنصر).
 */
const adjugate = (m) => [
  m[4] * m[8] - m[5] * m[7],
  m[2] * m[7] - m[1] * m[8],
  m[1] * m[5] - m[2] * m[4],
  m[5] * m[6] - m[3] * m[8],
  m[0] * m[8] - m[2] * m[6],
  m[2] * m[3] - m[0] * m[5],
  m[3] * m[7] - m[4] * m[6],
  m[1] * m[6] - m[0] * m[7],
  m[0] * m[4] - m[1] * m[3],
];

const multiply = (a, b) => {
  const c = new Array(9).fill(0);
  for (let i = 0; i < 3; i++)
    for (let j = 0; j < 3; j++)
      for (let k = 0; k < 3; k++) c[3 * i + j] += a[3 * i + k] * b[3 * k + j];
  return c;
};

const multiplyVector = (m, v) => [
  m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
  m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
  m[6] * v[0] + m[7] * v[1] + m[8] * v[2],
];

/* p1=(0,0) p2=(w,0) p3=(0,h) p4=(w,h) */
const basisToPoints = (x1, y1, x2, y2, x3, y3, x4, y4) => {
  const m = [x1, x2, x3, y1, y2, y3, 1, 1, 1];
  const v = multiplyVector(adjugate(m), [x4, y4, 1]);
  return multiply(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]);
};

export const quadToMatrix3d = (w, h, [tl, tr, br, bl]) => {
  const src = basisToPoints(0, 0, w, 0, 0, h, w, h);
  const dst = basisToPoints(tl.x, tl.y, tr.x, tr.y, bl.x, bl.y, br.x, br.y);
  const t = multiply(dst, adjugate(src));
  if (!t[8]) return "none";
  const n = t.map((v) => v / t[8]);
  return `matrix3d(${n[0]},${n[3]},0,${n[6]},${n[1]},${n[4]},0,${n[7]},0,0,1,0,${n[2]},${n[5]},0,${n[8]})`;
};
